module.exports = __webpack_public_path__ + "img/image.931dee43.png";